import {
  IFinancingNeedsExecutiveSummaryForm,
  IResearchCost,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';

import { getChartBgColor } from './getChartBgColor';
import { getChartTitle } from './getChartTitle';
import { getRoundedValues } from './getRoundedValues';
import { useGetFundingDirectionsDisplayOrder } from '../constants/displayOrder';
import { IFundingDirectionChartItem } from '../types';

export const useGetFundingNeedsChartData = (data: IFinancingNeedsExecutiveSummaryForm, isOutlined?: boolean) => {
  const FUNDING_NEEDS_DISPLAY_ORDER = useGetFundingDirectionsDisplayOrder();
  return Object.entries(data as Record<string, IResearchCost>)
    .reduce((acc: IFundingDirectionChartItem[], [key, { percentage }]) => {
      acc.push({
        percentage: getRoundedValues(parseFloat(percentage)),
        title: getChartTitle(key),
        color: getChartBgColor(key, isOutlined),
      });

      return acc;
    }, [])
    .sort((a, b) => FUNDING_NEEDS_DISPLAY_ORDER.indexOf(a.title) - FUNDING_NEEDS_DISPLAY_ORDER.indexOf(b.title))
    .filter(({ percentage }) => !isNaN(percentage) && percentage);
};
